// PublicTourRoute.jsx
import React from 'react';
import { useParams } from 'react-router-dom';
import TourViewer from './TourViewer';

const PublicTourRoute = () => {
  const { tourId } = useParams();

  return (
    <div className="h-screen w-screen">
      <div className="flex items-center gap-2 text-blue-600">
        <span>🌐</span>
      </div>
      <TourViewer mode="public" publicTourId={tourId} />
    </div>
  );
};

export default PublicTourRoute;
